










import { Component } from 'vue-property-decorator';
import BaseLogin from '@/components/login/BaseLogin';
import { PostAuthTokenRequest, AuthToken } from 'supporter';
import { setSessionCookie, setToken } from '@/utils/dataUtils';
import { I18N_LOCALE } from '@/const/words/cookie';
import {namespace} from 'vuex-class';
import Cookies from 'js-cookie';
const adminModule = namespace('admin');
const mallModule = namespace('mall');
const orderEnumsModule = namespace('orderEnums');
import SecurityAuthentication from '@/components/login/SecurityAuthentication.vue';
import { sanitizeRedirectPath } from '@/utils/sanitizeRedirectPath';
import { logSend } from '@/utils/logUtils';

type SecondAuthData = {
  key: string;
  plan?: string;
  target: {
    email?: string;
    enableOtp: boolean;
    mobile?: string;
  };
  type?: string;
  types: string[];
}

@Component({
  components: {
    SecurityAuthentication
  }
})
export default class OauthCodeReceiver extends BaseLogin {
  @adminModule.Action('fetchMainMenus') private readonly fetchMainMenus: (refreshFlg: boolean) => Promise<void>;
  @mallModule.Action('fetchMalls') private readonly fetchMalls: (refreshFlg: boolean) => Promise<void>;

  @orderEnumsModule.Action('fetchOrderConfigsEnums')
  private readonly fetchOrderConfigsEnums!: () => Promise<void>;

  private secondAuthData: SecondAuthData = {
    key: '',
    plan: '',
    target: {
      email: '',
      enableOtp: false,
      mobile: '',
    },
    type: '',
    types: [],
  };
  private isSecondAuthPopupOpen = false;
  private closePopup() {
    this.isSecondAuthPopupOpen = false;

    window.location.href = '/login';
  }

  private completeSecondAuth(authToken: AuthToken) {
    setSessionCookie();
    this.afterSuccessLogin(authToken);

    alert('관리자 접속이 승인되었습니다.');
    this.isSecondAuthPopupOpen = false;
  }


  private async afterSuccessLogin(authTokenData){
    const {accessToken, refreshToken, planType, autoLogoutMin} = authTokenData;

    if (planType === 'BASIC' || planType === 'PRO') {
      alert(this.$t('ALERT_CHECK_PLAN_TYPE', { planType }));
      window.location.href = process.env.VUE_APP_PRO_ADMIN_URL;
      throw 'invalid plan type';
    }

    if (planType !== 'PREMIUM' && planType !== 'STANDARD') {
      alert(this.$t('VIEW_LOGIN_ADMIN_FAIL_MESSAGE'));
      throw 'invalid plan type';
    }

    const admin = await setToken(accessToken, refreshToken, autoLogoutMin);

    let i18nLocale = 'kr';
    const {data} = await this.$api.getAdminsService({params: {searchType: 'ADMIN_ID', keyword: admin.id}});
    const myAdmin = data.contents.find((tempAdmin) => tempAdmin.adminId === admin.id);
    if (myAdmin) {
      switch (myAdmin.language) {
        case 'CHINESE':
          i18nLocale = 'zh';
          break;
        case 'JAPANESE':
          i18nLocale = 'jp';
          break;
        case 'ENGLISH':
          i18nLocale = 'en';
          break;
        default:
          i18nLocale = 'kr';
          break;
      }
    }
    Cookies.set(I18N_LOCALE, i18nLocale);
    this.$i18n.locale = i18nLocale;

    Promise.all([
      // 로그인 후 주문 enums 세팅
      this.fetchOrderConfigsEnums(),
      // 로그인했을 때 메뉴와 몰정보 새로 받아 로컬스토리지에 저장하도록 처리
      this.fetchMainMenus(true),
      this.fetchMalls(true)
    ]).then(() => this.redirectAfterLogin());
  }

  private postTokenHandler() {
    const code = this.$route.query?.code?.toString();
    const redirectUrl = this.$route.query?.state?.toString();
    code && this.postAuthToken(code, sanitizeRedirectPath(redirectUrl));
  }

  private postAuthToken(code: string, redirectUrl?: string) {
    const { VUE_APP_PREMIUM_ADMIN_URL, VUE_APP_COMMERCE_MAIN } = process.env;
    const sanitizedRedirectUrl = sanitizeRedirectPath(redirectUrl);
    const request: PostAuthTokenRequest = {
      data: {
        adminType: 'SERVICE',
        grantType: 'OAUTH_CODE',
        code,
        redirectUrl: `${VUE_APP_PREMIUM_ADMIN_URL}/oauth/redirect`,
      },
    };


    this.$api
      .postAuthToken(request)
      .then(res => {
        this.$router.push({ name: 'Login', query: { ...res.data, autoLogoutMin: res.data.autoLogoutMin.toString(), redirectUrl: sanitizedRedirectUrl} });
      })
      .catch((e) => {
        if (e.data.status === 400 && e.data.code && e.data.code.includes('AU1001')) {
          if (!['BASIC', 'PARTNER', 'PREMIUM', 'PRO', 'STANDARD'].includes(e.data.body?.plan)) {
            logSend(
              JSON.stringify({
                type: 'two-factor-auth',
                data: {
                  body: {
                    plan: e.data.body?.plan,
                    type: e.data.body?.type,
                  },
                  message: e.data.message,
                  method: e.data.method,
                  path: e.data.path,
                  status: e.data.status,
                  timestamp: e.data.timestamp,
                },
              })
            );
          }
          this.secondAuthData = {
            ...this.secondAuthData,
            ...e.data.body,
          };

          this.isSecondAuthPopupOpen = true;
          return;
        }
        window.open(VUE_APP_COMMERCE_MAIN, '_self');
      });
  }

  created() {
    this.postTokenHandler();
  }
}
